import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ConfigProvider } from '../../../../providers/config/config';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { LidProvider } from '../../../../providers/lid-provider/lid-provider';
import { IActivity, IPlayer, ITeam, ProfileConfigs } from '../../lineup/services/lineup-service';
import { SportAlgoUtils } from './sport.algo';

const saveKey$ = "gamerServiceSaveKey";
export const offlineUnloadKey$ = "onlineUnloadKey";

@Injectable()
export class TournamentService {
    testServer:boolean = false;

    planList = [];
    $planListChangeSub = new Subject();
    counters = {
        winScore: 3,
        tieScore: 1,
        lossScore: 0
    };

    constructor(
        private httpClient: HttpClient,
        private config: ConfigProvider,
        private translate: TranslateService,
        private lidProvider: LidProvider,
        private appDetector: AppDetectorProvider
    ) {
        new Promise<any>(async (resolve, reject) => {
            if(!this.appDetector.isTournamentApp()) return;

            this.requestProfileConfigs().then(configs => {
                this.counters.tieScore = configs.tieScore;
                this.counters.winScore = configs.winScore;
                this.counters.lossScore = configs.lossScore;
            }).catch(err => {
                console.warn('err: ', err);
            });

            let unload = localStorage.getItem(offlineUnloadKey$) || "false";
            this.planList = JSON.parse(localStorage.getItem(saveKey$)) || [];

            if (navigator.onLine) {
                if (unload.includes('true')) {
                    for (let i = 0; i < this.planList.length; i++) {
                        await this.saveTou(this.planList[i]);
                    }
                }
                this.getPlanList();
                localStorage.setItem(offlineUnloadKey$, "false");
            }
        });
    }

    getPlanList() {
        return new Promise<any>(async (resolve, reject) => {
            if (!navigator.onLine) resolve([]);
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/all` : `https://spooorts.de/tournament/user/${token}/tournament/all`;
            this.httpClient.get(url).toPromise()
                .then((res: any) => {
                    this.planList = res;
                    this.filterAll();
                    resolve(this.planList);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    filterAll() {
        for (let i = 0; i < this.planList.length; i++) {
            switch (this.planList[i].plantype) {
                case PlanEnum.PlanOnePage: this.planList[i] = SportAlgoUtils.transformJgj(this.planList[i]); break;
                case PlanEnum.KoPage: this.planList[i] = SportAlgoUtils.transformKo(this.planList[i]); break;
                case PlanEnum.VorPage: this.planList[i] = SportAlgoUtils.transformVor(this.planList[i]); break;
                case PlanEnum.VorKoPage: this.planList[i] = SportAlgoUtils.transformVorKo(this.planList[i]); break;
                case PlanEnum.MePage: this.planList[i] = SportAlgoUtils.transformMeKo(this.planList[i]); break;
            }
        }
    }

    transform(plan) {
        switch (plan.plantype) {
            case PlanEnum.PlanOnePage: return SportAlgoUtils.transformJgj(plan);
            case PlanEnum.KoPage: return SportAlgoUtils.transformKo(plan);
            case PlanEnum.VorPage: return SportAlgoUtils.transformVor(plan);
            case PlanEnum.VorKoPage: return SportAlgoUtils.transformVorKo(plan);
            case PlanEnum.MePage: return SportAlgoUtils.transformMeKo(plan);
            default: return plan;
        }
    }


    saveTeam(model: any) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/team/save` : `https://spooorts.de/tournament/user/${token}/tournament/team/save`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, model, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    saveTreeImage(id: number, imageFormData: any) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem('token');
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/image/${id}/save` : `https://spooorts.de/tournament/user/${token}/tournament/image/${id}/save`;
            this.httpClient.post(url, imageFormData, { observe: 'response' })
                .toPromise().then((response) => {
                    if (response.status === 200) {
                        console.log('Successfully saved!');
                        resolve(null);
                    } else {
                        console.log('Image not uploaded due to some error!');
                        reject();
                    }
                }
            );
        });
    }

    saveTeams(model: any) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/teams/save` : `https://spooorts.de/tournament/user/${token}/tournament/teams/save`;
            console.log('url: ' +  url);
            let httpHeaders = new HttpHeaders();
            this.httpClient.post(url, model, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    console.warn('a-1');
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    saveTou(plan: any) {
        return new Promise<any>(async (resolve, reject) => {
            if (!navigator.onLine) { localStorage.setItem(offlineUnloadKey$, "true"); resolve(plan); }
            let model = JSON.parse(JSON.stringify(plan));
            let lid = await this.lidProvider.getLid().then(lid => lid);
            model.lid = lid;
            model.gameTable = SportAlgoUtils.createOneDimArray(model.gameTable);
            if (model.roundGameTable && model.roundGameTable.length) {
                model.gameTable = model.gameTable.concat(SportAlgoUtils.createOneDimArray(model.roundGameTable));
            }
            let token = localStorage.getItem("token");
            let body = JSON.parse(JSON.stringify(model));
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/save` : `https://spooorts.de/tournament/user/${token}/tournament/save`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, body, {
                headers: httpHeaders
            }).toPromise()
                .then((res: any) => {
                    resolve(this.transform(res));
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    savePlayer(model: IPlayer) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/player/save` : `https://spooorts.de/tournament/user/${token}/tournament/player/save`;
            let body = JSON.parse(JSON.stringify(model));
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, body, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


    loadTou(id: number) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `user/${token}/tournament/config/${id}` : `https://spooorts.de/tournament/user/${token}/tournament/config/${id}`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.get(url, {
                headers: httpHeaders
            }).toPromise()
                .then((res: any) => {
                    if(res.pairs){
                        res.gameTable = res.pairs;
                        delete res.pairs;
                    }
                    resolve(this.transform(res));
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    saveGamePair(model: any) {
        return new Promise<any>(async (resolve, reject) => {
            if (!navigator.onLine) { localStorage.setItem(offlineUnloadKey$, "true"); return; }
            let lid = await this.lidProvider.getLid().then(lid => lid);
            model.lid = lid;
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/gamepair/save` : `https://spooorts.de/tournament/user/${token}/gamepair/save`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, model, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    loadTeam(id: number) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/team/${id}` : `https://spooorts.de/tournament/user/${token}/tournament/team/${id}`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.get(url, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    console.log('res', res)
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getTeamName(activePlan: number, teamIndex: number) {
        if (this.planList[activePlan] && this.planList[activePlan].teams[teamIndex]) {
            return this.planList[activePlan].teams[teamIndex].name;
        }
        return this.translate.instant("NO_TURNIERS_YET");
    }

    save() {
        localStorage.setItem(saveKey$, JSON.stringify(this.planList));
    }

    removePlayerById(id: number) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/player/${id}/delete` : `https://spooorts.de/tournament/user/${token}/tournament/player/${id}/delete`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.get(url, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    removeTeamById(id: number) {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem('token');
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/team/${id}/delete` : `https://spooorts.de/tournament/user/${token}/tournament/team/${id}/delete`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, id,{
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    removeTouById(id: number) {
        console.log('removeTouById')
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/tournament/${id}/delete` : `https://spooorts.de/tournament/user/${token}/tournament/${id}/delete`;
            let httpHeaders = new HttpHeaders();
            httpHeaders.append('Content-Type', 'application/json');
            this.httpClient.post(url, id, {
                headers: httpHeaders
            }).toPromise()
                .then(res => {
                    this.planList = this.planList.filter(e => e.id != id);
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    addTeam(activePlan: number, team: ITeam): number {
        this.createPlanIfEmpty();
        let indexOf = this.planList[activePlan].teams.findIndex(t => t.name == team.name);
        if (indexOf >= 0) {
            return indexOf;
        } else {
            this.planList[activePlan].teams.push(team);
            this.saveTou(this.planList[activePlan]).then(id => this.planList[activePlan].id = id);
            return this.planList[activePlan].teams.length - 1;
        }
    }

    /**
     * 
     * @returns the initial state of the plan list. "true" - was empty, "false" - was not empty
     */
    createPlanIfEmpty(planName: string = null): boolean {
        if (!this.planList.length) {
            let plan = {
                id: 0,
                plantype: PlanEnum.Scratch,
                eventId: -1,
                sportArt: "Fußball",
                name: planName || "Spielplan " + (this.planList.length + 1) + ' - Lineup',
                teamNum: "1",
                games: "1",
                rounds: 1,
                days: 7,
                groupNum: 2,
                groupSize: 4,
                roundPhase: false,
                teams: [],
                gameTable: [],
                roundTeams: [],
                roundGameTable: []
            };
            this.planList.push(plan);
            return true;
        }
        return false;
    }

    async saveProfileConfigs() {
        let model = {
            lid: null,
            encounters: 0,
            tieScore: this.counters.tieScore,
            lossScore: this.counters.lossScore,
            winScore: this.counters.winScore
        };
        let lid = await this.lidProvider.getLid().then(lid => lid);
        model.lid = lid;
        let token = localStorage.getItem("token");
        let url = this.testServer ? `http://localhost:8080/user/${token}/profile/save` : `https://spooorts.de/tournament/user/${token}/profile/save`;
        let httpHeaders = new HttpHeaders();
        httpHeaders.append('Content-Type', 'application/json');
        this.httpClient.post(url, model, {
            headers: httpHeaders
        }).toPromise()
            .then(res => {
                console.log('res: ', res);
            })
            .catch(err => {
                console.log('err: ', err);
            });
    }


    requestProfileConfigs() {
        return new Promise<any>(async (resolve, reject) => {
            let token = localStorage.getItem("token");
            let url = this.testServer ? `http://localhost:8080/user/${token}/profile` : `https://spooorts.de/tournament/user/${token}/profile`;
            this.httpClient.get(url).toPromise()
                .then((res: ProfileConfigs) => {
                    resolve(res);
                })
                .catch(err => {
                    alert(err);
                    reject(err);
                });
        });
    }

    removeTeam(plan: number, team: any) {
        let teamIndex = team;
        if (typeof team != "number") {
            teamIndex = this.planList[plan].teams.indexOf(team);
        }
        this.planList[plan].teams.splice(teamIndex, 1);
        this.removeTeamById(team.id);
    }

    setActivity(activity: IActivity, plan: number, team: number) {
        if (this.planList[plan] && this.planList[plan].teams[team])
            this.planList[plan].teams[team].activity = activity;
    }
}

export interface IPlanOption {
    id: number;
    name: string;
    description?: string;
    preround?: string;
    finalround?: string;
    finalstage?: string;
    place?: string;
    additional?: string;
}

export enum PlanEnum {
    "PlanOnePage",
    "KoPage",
    "VorPage",
    "VorKoPage",
    "GruKoPage",
    "GruKoPlPage",
    "GruPlPage",
    "MePage",
    "Scratch"
}

export const PlanOptions: IPlanOption[] = [{
    id: PlanEnum.PlanOnePage,
    name: "EVERYONE_AGAINST_EVERYONE",
    description: "LEAGUE",
    // place: "Platz 1"
}, {
    id: PlanEnum.KoPage,
    name: "KO_SYSTEM",
    description: "KO_SYSTEM_DESC"
}, {
    id: PlanEnum.VorPage,
    name: "GROUP_STAGE",
    description: "GROUP_STAGE_DESC",
    preround: "GROUP_STAGE_PREROUND",
    // additional: "Gewinner müssen in nächsten Spielplan eingefügt werden!"
},
// {
//     id: PlanEnum.VorKoPage,
//     name: "Vorrunde -> KO-System",
//     preround: "Jeder gegen Jeden",
//     finalround: "KO-System",
//     // place: "Platz 1 bis 4"
// }, {
//     id: PlanEnum.GruKoPage,
//     name: "2 Gruppen -> KO-System",
//     preround: "Gruppen (Jeder gegen Jeden)",
//     finalround: "KO-System",
//     // place: "Platz 1 bis 4"
// }, {
//     id: PlanEnum.GruKoPlPage,
//     name: "2 Gruppen -> KO-System + Platzierungsspiele",
//     preround: "Gruppen (Jeder gegen Jeden)",
//     finalstage: "KO-System + Platzierungsspiele",
//     // place: "Platz 1 bis Ende"
// }, {
//     id: PlanEnum.GruPlPage,
//     name: "2 Gruppen -> Platzierungsspiele",
//     preround: "Gruppen (Jeder gegen Jeden)",
//     finalstage: "Platzierungsspiele",
//     // place: "Platz 1 bis Ende"
// },
{
    id: PlanEnum.MePage,
    name: "MULTIPLE_GROUPS",
    preround: "GROUP_STAGE_PREROUND",
    finalstage: "KO_SYSTEM",
    // place: "Platz 1 bis 4"
}];

export interface IPlan {
    sporttype: number;
    plantype: number;
    name: string;
    days: number;
    eventId: number;
    teamNum: number;
    games: number;
    teams: any;
    rounds: number;
    gameTable?: any;
    id?: number;
    groupNum?: number;
    groupSize?: number;
    date?: string;
    time?: string;
}




// WEBPACK FOOTER //
// /src/pages/apps/gamer/services/tournament.service.ts